export default { now: () => new Date() };